import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class RefreshButtonModel extends ButtonBase {
    label: string = 'Refresh';
    action: string = ACTION_STATUS.refresh;
    matIconName: string = 'refresh';
    colorClass: string = '';
}